import { createClient } from '@libsql/client';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_HEADER_CONTENT = {
  lastUpdated: new Date().toISOString(),
  navItems: [
    { name: 'Home', path: '/' },
    { name: 'Godrej MSR City', path: '/godrej-barca' },
    { name: 'Godrej Shettigre', path: '/godrej-shettigere' },
    { name: 'Properties', path: '/properties' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ],
  adminDashboardLink: { name: 'Admin Dashboard', path: '/aadashmin' },
  mobileCta: { text: "Let's Connect", link: "/contact" }
};

async function ensureTableExists() {
  try {
    await db.execute(`
      CREATE TABLE IF NOT EXISTS header_content (
        id TEXT PRIMARY KEY,
        content_data TEXT NOT NULL,
        updated_at TEXT NOT NULL
      );
    `);
  } catch (error) {
    console.error("Error creating header_content table:", error);
    throw new Error('Could not create header_content table in database.');
  }
}

async function getHeaderContent() {
  await ensureTableExists();
  try {
    const result = await db.execute({
      sql: `SELECT content_data, updated_at FROM header_content WHERE id = ?`,
      args: ['header-content'],
    });

    if (result.rows.length > 0) {
      const content = JSON.parse(result.rows[0].content_data);
      content.lastUpdated = result.rows[0].updated_at;
      return content;
    } else {
      console.log('No content found for Header, returning default and saving it.');
      await createOrUpdateHeaderContent(DEFAULT_HEADER_CONTENT);
      return DEFAULT_HEADER_CONTENT;
    }
  } catch (error) {
    console.error("Error fetching Header content:", error);
    throw new Error('Could not fetch Header content from database.');
  }
}

async function createOrUpdateHeaderContent(content) {
  await ensureTableExists();
  const now = new Date().toISOString();
  try {
    const serializedContent = JSON.stringify({ ...content, lastUpdated: now });
    await db.execute({
      sql: `
        INSERT INTO header_content (id, content_data, updated_at) VALUES (?, ?, ?)
        ON CONFLICT(id) DO UPDATE SET content_data = ?, updated_at = ?;
      `,
      args: [
        'header-content',
        serializedContent,
        now,
        serializedContent,
        now
      ],
    });
    console.log('Header content created or updated successfully!');
    return JSON.parse(serializedContent);
  } catch (error) {
    console.error("Error creating or updating Header content:", error);
    throw new Error('Could not save Header content to database.');
  }
}

export const headerService = {
  getHeaderContent,
  createOrUpdateHeaderContent
};